import { render, staticRenderFns } from "./paymentAccountOpening.vue?vue&type=template&id=258774d5&scoped=true"
import script from "./paymentAccountOpening.vue?vue&type=script&lang=js"
export * from "./paymentAccountOpening.vue?vue&type=script&lang=js"
import style0 from "./paymentAccountOpening.vue?vue&type=style&index=0&id=258774d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258774d5",
  null
  
)

export default component.exports